import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FleetService } from '../../../services/fleet/fleet.service';
import { TripService } from '../../../services/trip/trip.service'; 
import { TokenStorage } from '../../../auth/token.storage';
import { AngularFireDatabase } from '@angular/fire/database';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { AgmMap, LatLngBounds } from '@agm/core';
declare const google: any;

@Component({
  selector: 'app-fleetmapview',
  templateUrl: './fleetmapview.component.html',
  styleUrls: ['./fleetmapview.component.scss']
})
export class FleetmapviewComponent implements OnInit, OnDestroy {

  availableCount: number = 0;
  unavailableCount: number = 0;
  inplanningCount: number = 0;
  scheduledCount: number = 0;
  intransitCount: number = 0;

  isTenantDiag = false;
  
  zoom: number = 13;
  lat: number = 18.533989;
  lng: number = 73.825592;
  OrderMapMarker: any;
  markers: any;
  markersArr = [];
  subscriptionsArray: Array<Subscription> = [];
  icon : any;
  @ViewChild('AgmMap') agmMap: AgmMap; 
  typeOfOrder:any='available';

  constructor(
    private fleetService: FleetService,
    private tripService: TripService,
    private db: AngularFireDatabase,
    private token: TokenStorage,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    if (this.token.getCustomerType() === 'Diagnostic') {
      this.isTenantDiag = true;
      this.icon = '../../../../assets/icons/bike3d.png';
    }else {
      this.fleetService.getFleetCountByStatus().subscribe(res => {
        this.availableCount = this.searchArraryForCount(res, 'FLEET_STATE_UNPLANNED');
        this.unavailableCount = this.searchArraryForCount(res, 'FLEET_STATE_INITIAL');
        this.inplanningCount = this.searchArraryForCount(res, 'FLEET_STATE_IN_PLANNING');
        this.scheduledCount = this.searchArraryForCount(res, 'FLEET_STATE_SCHEDULED');
        this.intransitCount = this.searchArraryForCount(res, 'FLEET_STATE_IN_TRANSIT');
      });
      this.icon = '../../../../assets/icons/truck3d.png';
    }

    //send type data here
    this.generateMapData();
  }

  searchArraryForCount(arr, value) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].fleetStatus === value) {
        return arr[i].fleetCount;
      }
    }
  }

  generateMapData() {
    this.markersArr = [];
    let date : any = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.tripService.getAllTripsByTypesDateRange('TRIP_STATE_IN_TRANSIT', 0, date, date, 'nozone').subscribe(trips =>{
      for(let i = 0; i < trips.content.length; i++){
        if(trips.content[i].tState === 'TRIP_STATE_IN_TRANSIT'){
          let path = '/' + this.token.getTenant() + '/' + trips.content[i].tripName;
          let sub = this.db.list(path).valueChanges().subscribe(res => {
            if(res[res.length-1]){
              let idx = this.markersArr.findIndex(obj => obj.tripName === trips.content[i].tripName);
              if(idx === -1 ){
                let temp = {
                  tripName : trips.content[i].tripName,
                  licenseNumber : trips.content[i].fleet.vehicleLicenseNumber,
                  icon : this.icon,
                  location : res[res.length - 1],
                  driver : trips.content[i].driver.firstName + " " + (trips.content[i].driver.lastName ? trips.content[i].driver.lastName : ''),
                  address : this.findAddressUsingLatLng(res[res.length - 1])
                }
                this.markersArr.push(temp);
              }else{
                this.markersArr[idx].address = this.findAddressUsingLatLng(res[res.length - 1]);
                this.markersArr[idx].location = res[res.length-1];
              }
            }
          });
          this.subscriptionsArray.push(sub);
        }
      }
    })
  }

  ngOnDestroy() {
    this.subscriptionsArray.forEach(subscrption => {
      subscrption.unsubscribe();
    });
  }

  findAddressUsingLatLng(location) {
    let geocoder = new google.maps.Geocoder;
    let latlng = { lat: location.latitude, lng: location.longitude };
    let address : string = '--';
    geocoder.geocode({ 'location': latlng }, (results, status) => {
      if(status === 'OK') {
        if (results)
        address = results[1].formatted_address;
      }
    });
    //console.log(address);
    return address;
  }

  ngAfterViewInit() {
    if(this.agmMap){
      this.agmMap.mapReady.subscribe(map => {
        console.log("Map Ready");
        setTimeout(() => {
          console.log("Zoom Set");
          const bounds: LatLngBounds = new google.maps.LatLngBounds();
          for (const mm of this.markersArr) {
            bounds.extend(new google.maps.LatLng(mm.location.latitude, mm.location.longitude));
            bounds.extend(new google.maps.LatLng(mm.location.latitude, mm.location.longitude));
          }
          map.fitBounds(bounds);
        }, 5000);
      });
    }
  }
}


